import { useMutation } from "@apollo/client";
import type { SetupOrganizationProjectPayload } from "@casey/db-types";
import { SETUP_ORGANIZATION_INTERVIEW_PROJECT } from "../gql";

interface SetupOrganizationInterviewProjectInput {
  organizationId: string;
  goalId: string;
  createdByUserId: string;
}

interface SetupOrganizationInterviewProjectVariables {
  organizationId: string;
  goalId: string;
  createdByUserId: string;
}

interface SetupOrganizationInterviewProjectResponse {
  setupOrganizationInterviewProject: SetupOrganizationProjectPayload;
}

export function useSetupOrganizationInterviewProject() {
  const [setupOrganizationInterviewProjectMutation, { data, loading, error }] =
    useMutation<
      SetupOrganizationInterviewProjectResponse,
      SetupOrganizationInterviewProjectVariables
    >(SETUP_ORGANIZATION_INTERVIEW_PROJECT, {
      errorPolicy: "all",
    });

  const setupOrganizationInterviewProject = async (
    input: SetupOrganizationInterviewProjectInput,
  ) => {
    try {
      const result = await setupOrganizationInterviewProjectMutation({
        variables: {
          organizationId: input.organizationId,
          goalId: input.goalId,
          createdByUserId: input.createdByUserId,
        },
      });

      const setupResult = result.data?.setupOrganizationInterviewProject;
      if (setupResult?.json) {
        return setupResult.json;
      }

      return setupResult;
    } catch (err) {
      console.error("Error setting up organization interview project:", err);
      throw err;
    }
  };

  return {
    setupOrganizationInterviewProject,
    data: data?.setupOrganizationInterviewProject,
    loading,
    error,
  };
}

export type { SetupOrganizationInterviewProjectInput };
